import styled from 'styled-components'

export default styled.footer`
  position: fixed;
  z-index: 101;
  left: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #ffffff;
  border-top: 1px solid #c7c7cc;
  padding-bottom: 0;
  height: 50px;

  a {
    position: relative;
    padding: 11px 10vw;

    &:not(.active) {
      img {
        /* filter: invert(0.6); */
        opacity: 0.5;
      }
    }


  }

  .footer-icon {
    display: block;

    &--explore {
      width: 28px;
    }
  }

  .bag-logo-badge {
    position: absolute;
    /* top: -6px;
    right: -9px; */
    top: 50%;
    left: 50%;
    transform: translate(0, -50%);
    margin: -8px 0 0 2px;
  }

  padding-bottom: env(safe-area-inset-bottom);
  height: calc(50px + env(safe-area-inset-bottom));
`



// WEBPACK FOOTER //
// ./src/styles/Footer.js